/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Agent_Composer_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Tell the agent what to change (Enter to send, Shift+Enter for a new line)" |
*
* @param {Assistant_Agent_Composer_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_agent_composer_placeholder = /** @type {((inputs?: Assistant_Agent_Composer_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Agent_Composer_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Indiquez à l'agent les modifications à apporter (Appuyez sur Entrée pour envoyer, Maj+Entrée pour une nouvelle ligne).")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sagen Sie dem Agenten, was geändert werden soll (Eingabetaste zum Senden, Umschalt+Eingabetaste für eine neue Zeile).")
	if (locale === "it") return /** @type {LocalizedString} */ ("Comunica all'agente cosa modificare (Invio per inviare, Maiusc+Invio per andare a capo).")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Укажите оператору, что нужно изменить (Enter для отправки, Shift+Enter для новой строки).")
	if (locale === "es") return /** @type {LocalizedString} */ ("Indica al agente qué cambios debe realizar (pulsa Intro para enviar, Mayús+Intro para insertar una nueva línea).")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("告诉客服人员要更改什么（按回车键发送，按Shift+回车键换行）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("変更内容をエージェントに伝えてください（Enterキーで送信、Shift+Enterキーで改行）。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एजेंट को बताएं कि क्या बदलना है (भेजने के लिए एंटर दबाएं, नई लाइन के लिए Shift+Enter दबाएं)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Diga ao agente o que deve ser alterado (Pressione Enter para enviar, Shift+Enter para uma nova linha).")
	return /** @type {LocalizedString} */ ("Tell the agent what to change (Enter to send, Shift+Enter for a new line)")
});